<template>
  <div class="card" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Date</th>
          <th>Coefficient Name</th>
          <th>Coefficient Number</th>
          <th>Customer</th>
          <th class="text-right">Bill of material cost</th>
          <th class="text-right">Total sale price</th>
          <th>Currency</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in inputOutputCoefficient" :key="i">
          <td> {{ item.date }}</td>
          <td> {{ item.product_costing_name }}</td>
          <td> {{ item.bill_number }}</td>
          <td> {{ item.customer_name }}</td>
          <td class="text-right"> {{ commaFormat(item.bom_cost) }}</td>
          <td class="text-right"> {{ commaFormat(item.total_sales_price) }}</td>
          <td> {{ item.currency }}</td>
          <td>
            <button class="btn btn-secondary btn-sm"
                    @click="goToMushak43Print(item.id)"
                    style="cursor: pointer"
                    title="Mushak 4.3"
            >
              <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!inputOutputCoefficient.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter';
import {inject} from 'vue'
import {useRoute} from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleCompany from '@/services/modules/company'
import printMushak43 from '@/services/utils/pdf/mushak43Pdf'

const props = defineProps({
  inputOutputCoefficient: Array
})

const $route = useRoute()
const showError = inject('showError')

const {commaFormat} = figureFormatter()
const {fetchSingleProductCosting} = handlePurchase()
const {fetchCompanyInfo} = handleCompany()
const {exportToPdfMushak43} = printMushak43()

async function goToMushak43Print(id) {
  const companyQuery = `?company_id=${$route.params.companyId}`
  try {
    const costingRes = fetchSingleProductCosting(id, companyQuery)
    const companyRes = fetchCompanyInfo($route.params.companyId)
    const [costingResponse, companyResponse] = await Promise.all([costingRes, companyRes])
    if (!costingResponse.data) return
    await exportToPdfMushak43(companyResponse.data, costingResponse.data)
  } catch (err) {
    showError('Something went wrong')
  }
}
</script>
